import React from 'react';
import { IconTooltip } from './IconTooltip';

interface ProgressStep {
    status: string;
    label: string;
    icon: React.ReactNode;
}

export interface ProgressTrackerProps {
    title?: string;
    steps: ProgressStep[];
    currentStatusIndex: number;
}

export const ProgressTracker: React.FC<ProgressTrackerProps> = ({
    title = 'Order Progress',
    steps,
    currentStatusIndex,
}) => {
    return (
        <div className="bg-card rounded-2xl border shadow-sm p-6">
            <p className="font-bold text-foreground text-sm uppercase tracking-wider opacity-70 mb-6">
                {title}
            </p>
            <div className="flex items-start justify-between relative">
                <div className="absolute top-5 left-0 right-0 h-0.5 bg-secondary/20 z-0" />
                <div
                    className="absolute top-5 left-0 h-0.5 bg-primary z-0 transition-all duration-500"
                    style={{
                        width: currentStatusIndex >= 0
                            ? `${(currentStatusIndex / (steps.length - 1)) * 100}%`
                            : '0%'
                    }}
                />
                {steps.map((step, index) => {
                    const isCompleted = index < currentStatusIndex;
                    const isActive = index === currentStatusIndex;
                    return (
                        <div key={step.status} className="flex flex-col items-center gap-2 z-10 flex-1">
                            <IconTooltip content={step.label}>
                                <div className={`w-10 h-10 rounded-full flex items-center justify-center border-2 transition-all duration-300 ${isCompleted ? 'bg-primary border-primary text-primary-foreground'
                                    : isActive ? 'bg-primary/10 border-primary text-primary ring-4 ring-primary/20'
                                        : 'bg-card border-secondary/30 text-muted-foreground'
                                    }`}>
                                    {step.icon}
                                </div>
                            </IconTooltip>
                            <span className={`text-[10px] font-semibold text-center leading-tight ${isActive ? 'text-primary' : isCompleted ? 'text-foreground' : 'text-muted-foreground'
                                }`}>
                                {step.label}
                            </span>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};
